import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

// Komponen untuk Bar Chart sederhana
const BarChart = ({ data }) => {
    const maxValue = Math.max(...Object.values(data));
    const colors = {
        Draft: '#6c757d',
        Sent: '#17a2b8',
        Paid: '#28a745',
        Overdue: '#dc3545',
    };

    return (
        <div style={styles.chartContainer}>
            <div style={styles.chartBars}>
                {Object.entries(data).map(([key, value]) => (
                    <div key={key} style={styles.barWrapper}>
                        <div style={{
                            height: `${(value / (maxValue || 1)) * 100}%`,
                            width: '100%',
                            backgroundColor: colors[key] || '#ccc',
                            borderRadius: '4px 4px 0 0',
                            transition: 'height 0.5s ease-in-out',
                        }}>
                           <span style={styles.barValue}>{value}</span>
                        </div>
                        <div style={styles.barLabel}>{key}</div>
                    </div>
                ))}
            </div>
             <div style={styles.yAxis}>
                <span>{maxValue}</span>
                <span>{Math.round(maxValue / 2)}</span>
                <span>0</span>
            </div>
        </div>
    );
};


const Report = () => {
    const [reportData, setReportData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        const fetchReportData = async () => {
            const token = localStorage.getItem('token');
            if (!token) {
                navigate('/login');
                return;
            }
            try {
                const config = { headers: { 'x-auth-token': token } };
                const res = await axios.get('https://planstopia-production.up.railway.app/api/reports/by-status', config);
                setReportData(res.data);
            } catch (err) {
                setError('Gagal mengambil data laporan.');
                console.error(err);
            } finally {
                setLoading(false);
            }
        };

        fetchReportData();
    }, [navigate]);

    if (loading) return <div style={styles.container}><h2>Memuat laporan...</h2></div>;
    if (error) return <div style={styles.container}><p style={{color: 'red'}}>{error}</p></div>;

    return (
        <div style={styles.page}>
            <header style={styles.navbar}>
                <h1 style={{cursor: 'pointer'}} onClick={() => navigate('/dashboard')}>Invoice App</h1>
                <div>
                     <button onClick={() => navigate('/invoices')} style={styles.navButton}>Lihat Invoice</button>
                </div>
            </header>
            <main style={styles.container}>
                <h2>Laporan Status Invoice</h2>
                <p>Visualisasi jumlah invoice berdasarkan status saat ini.</p>
                <div style={styles.reportContent}>
                    {reportData ? <BarChart data={reportData} /> : <p>Tidak ada data untuk ditampilkan.</p>}
                </div>
            </main>
        </div>
    );
};

const styles = {
    page: { fontFamily: 'Arial, sans-serif', background: '#f9fafb', minHeight: '100vh' },
    navbar: { background: '#fff', padding: '0 40px', borderBottom: '1px solid #ddd', display: 'flex', justifyContent: 'space-between', alignItems: 'center', height: '60px' },
    navButton: { marginLeft: '15px', padding: '8px 12px', background: '#007bff', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer' },
    logoutButton: { marginLeft: '15px', padding: '8px 12px', background: '#6c757d', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer' },
    container: { padding: '20px 40px', display: 'flex', flexDirection: 'column', alignItems: 'center' },
    reportContent: {
        background: 'white',
        borderRadius: '8px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
        padding: '30px',
        marginTop: '20px',
        width: '100%',
        maxWidth: '800px',
    },
    chartContainer: {
        position: 'relative',
        height: '300px',
        paddingLeft: '30px',
        borderLeft: '2px solid #ccc',
        borderBottom: '2px solid #ccc',
    },
    yAxis: {
        position: 'absolute',
        left: '-30px',
        top: 0,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        fontSize: '12px',
        color: '#666'
    },
    chartBars: {
        height: '100%',
        width: '100%',
        display: 'flex',
        justifyContent: 'space-around',
        alignItems: 'flex-end',
        gap: '20px'
    },
    barWrapper: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        height: '100%'
    },
    barValue: {
        position: 'absolute',
        top: '-20px',
        fontWeight: 'bold',
        color: '#333'
    },
    barLabel: {
        marginTop: '8px',
        fontSize: '14px',
        fontWeight: 'bold',
    }
};

export default Report;
